export default class ScoreTypeUnit {
  constructor (data) {
    this.id = data.id
    this.name = data.name
    this.precision = data.precision
    this.time = data.time
    this.period = data.period
  }
}
